import { createApi} from "@reduxjs/toolkit/query/react";
import customBaseQuery from "./base.api.ts";

interface Agent {
  agent_id: number;
  agent_username: string;
  agent_email: string
}

export const agentApi = createApi({
  reducerPath: "agentApi",
  baseQuery: customBaseQuery, 
  tagTypes: ['Agents'],
  endpoints: (builder) => ({
    getAgentsByCompany: builder.query<Agent[], void>({
        query: () => ({
          url: `/gw/agents/agents-list/company`,
          method: "get",
        }),
        providesTags: ['Agents'],
      }),
  }),
});

export const { 
  useGetAgentsByCompanyQuery 
} = agentApi;